import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { CompanyMember } from '../../models/member.model';
import { authToken } from '../../scripts/authentication.script';

export class ApiDigitalAuthMember {
  static apiResponse: ApiResponse

  public static async getCompanyMembers(
    api_key: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      this.apiResponse = {
        status: 200,
        message: 'Success',
        data: [] as CompanyMember[]
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/company/members`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data?.members ?? response.data?.data ?? response.data?.members ?? []
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }

  public static async assignRole(
    api_key: string,
    user_id: string,
    role_id: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      this.apiResponse = {
        status: 200,
        message: 'Success',
        data: { message: 'Role assigned' }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/company/members/${user_id}/roles`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.post(url, { role_id }, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data ?? null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }

  public static async unassignRole(
    api_key: string,
    user_id: string,
    role_id: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      this.apiResponse = {
        status: 200,
        message: 'Success',
        data: { message: 'Role removed' }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/company/members/${user_id}/roles/${role_id}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.delete(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data ?? null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }
}
